import React from "react";

import CD from "./component/CustomerDetails";
import Detaiils from "./productDetails";
import Terms from "./TermsCo";
import Privacy from "./Privacy";
import ContactUs from "./ContactUs";
import Replace from "./replace";
import Aboutus from "./abouts";
import RefundPolicy from "./RefundPolicy";
import SearchStore from "./Store";
import Category from "./Category";
import { BrowserRouter, Route, Switch } from "react-router-dom";

const RouterManager = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={SearchStore} />
      <Route exact path="/Details/:productName?" component={Detaiils} />
      <Route exact path="/Explore/Category/" component={Category} />

      <Route exact path="/Cart" component={CD} />
      <Route exact path="/PrivacyPolicy" component={Privacy} />
      <Route exact path="/TermsAndCondition" component={Terms} />
      <Route exact path="/Contact" component={ContactUs} />
      <Route exact path="/replace" component={Replace} />
      {/* <Route path="/About" component={Aboutus} />*/}
      <Route path="/RefundPolicy" component={RefundPolicy} />
    </Switch>
  </BrowserRouter>
);

export default RouterManager;
